import React from 'react';

const FooterTitle = ({title}) => {
  return (
    <div>
      <h1 className="text-white font-[500] uppercase text-[16px] pt-1.5 pb-10">{title}</h1>
    </div>
  );
};

export default FooterTitle;